import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }

import { ref, watch , inject } from 'vue';
import { usePreventivo } from '../../composable/usePreventivo'
import FormImmobiliareHelper from "./../../pages/preventivi/json/immobiliare/helper.json";
import DettaglioPreventivoHelper from "../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormImmobiliareAltriTrasferimenti',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo','infoCompilazione'],
  setup(__props, { emit: __emit }) {

const {
  categoriaImmobiliare
} = usePreventivo();
const props = __props;
let validazione;
const validazioneEquoCompenso = ref();
const { regimeFiscale } = inject('regimeFiscale')
const testoInfoCompilazione = ref([]);
const emits = __emit;
switch (props.formName) {
  case 'riscattoDaSocietaDiLeasing':
    validazione = categoriaImmobiliare['sottocategoriaAltriTrasferimenti']['riscattoDaSocietaDiLeasing'];
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaAltriTrasferimenti']['riscattoDaSocietaDiLeasing'];
    break
}
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
if(validazione){
  validazione.tipo_preventivo.value = 'immobiliare/altri_trasferimenti/' + props.tipoPreventivo.data.url
}
testoInfoCompilazione.value =  FormImmobiliareHelper.sottocategoriaAltriTrasferimenti[props.formName];
let indexHelperClosing= {
  calcolo: FormImmobiliareHelper.sottocategoriaAltriTrasferimenti[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}
emits('infoCompilazione',  testoInfoCompilazione);
watch(validazione, (newValue, oldValue) => {
  emits('changeDatiPreventivo');
}, { deep: true })

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'riscattoDaSocietaDiLeasing')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).prezzo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.prezzo.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_input_text, {
                id: "prezzo",
                name: "prezzo",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).prezzo,
                "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((_unref(validazione).prezzo) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_select, {
                name: "forma_del_titolo",
                options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                isSelected: _unref(validazione).forma_del_titolo.value != '',
                state: __props.readonly == true ?'disable':'',
                validateTo: _unref(validazione).forma_del_titolo,
                "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).forma_del_titolo) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          (_unref(regimeFiscale) == 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "prezzo",
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}